/**
 * Saves bytes the console fetched itself as a file: a same-origin object URL on a hidden anchor with `download`
 * (malible-premium-ui §2.8: the attribute is ignored for cross-origin URLs, so the bytes are fetched first). The object
 * URL is revoked once the browser has started the download.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const href = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.download = filename;
  anchor.rel = 'noopener';
  anchor.hidden = true;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(href), 60_000);
}
